"use client";

import { BodyText, breakpointTablet } from "@gnist/design-system";
import { styled } from "styled-components";
import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import {
  getCarInfoItems,
  Specifications as SpecificationsEnum,
} from "../utils/getCarInfoItems";
import { tokens } from "@gnist/themes/tokens.css.js";

interface Props {
  car: Car;
  showShortenedList?: boolean;
}

const ItemsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  column-gap: ${tokens.spacing.s};
  row-gap: ${tokens.spacing.s};

  @media screen and (max-width: ${breakpointTablet}) {
    gap: 0;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(33% - ${tokens.spacing.xs});
  word-wrap: break-word;

  @media screen and (max-width: ${breakpointTablet}) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 0.5px solid ${tokens.color.outline};
    padding: ${tokens.spacing.s} 0;
  }
  dd {
    word-break: break-word;
    @media screen and (max-width: ${breakpointTablet}) {
      text-align: right;
    }
  }
`;

const Label = styled.dt`
  font-size: ${tokens.typeface.size.s};

  @media screen and (max-width: ${breakpointTablet}) {
    font-size: ${tokens.typeface.size.base};
    padding-right: ${tokens.spacing.xs};
  }
`;

export const Specifications = ({ car, showShortenedList }: Props) => {
  const infoItems = getCarInfoItems(car);
  const infoItemsList = showShortenedList
    ? infoItems.filter(
        (item) =>
          item.id === SpecificationsEnum.BRAND ||
          item.id === SpecificationsEnum.MODEL ||
          item.id === SpecificationsEnum.VARIANT ||
          item.id === SpecificationsEnum.BASE_COLOR_CODE ||
          item.id === SpecificationsEnum.INTERIOR ||
          item.id === SpecificationsEnum.SEATS ||
          item.id === SpecificationsEnum.CURB_WEIGHT ||
          item.id === SpecificationsEnum.DRIVE_WHEEL,
      )
    : infoItems;

  return (
    <ItemsWrapper>
      {infoItemsList.map(
        (item) =>
          item.value && (
            <Item key={item.label}>
              <Label>{item.label}</Label>
              <BodyText
                style={{ fontWeight: tokens.typeface.weight.semibold }}
                $as="dd"
              >
                {item.value}
              </BodyText>
            </Item>
          ),
      )}
    </ItemsWrapper>
  );
};
